<template>
  <div class="learning-history-bg">
    <div class="page-header">
      <h2>学习记录</h2>
      <div class="filter-section">
        <el-select v-model="timeFilter" placeholder="时间筛选" size="small">
          <el-option label="全部" value="all"></el-option>
          <el-option label="最近一周" value="week"></el-option>
          <el-option label="最近一月" value="month"></el-option>
          <el-option label="最近三月" value="threemonths"></el-option>
        </el-select>
        <el-select v-model="statusFilter" placeholder="完成状态" size="small">
          <el-option label="全部" value="all"></el-option>
          <el-option label="已完成" value="completed"></el-option>
          <el-option label="进行中" value="inProgress"></el-option>
          <el-option label="未开始" value="notStarted"></el-option>
        </el-select>
      </div>
    </div>

    <div class="course-list">
      <div v-for="course in filteredCourses" :key="course.id" class="course-item">
        <img :src="course.image" :alt="course.name" class="course-img">
        <div class="course-info">
          <div class="course-title-row">
            <span class="course-title">{{ course.name }}</span>
            <el-button v-if="course.progress < 100" type="primary" size="mini" class="continue-btn">继续学习</el-button>
            <el-button v-else type="info" size="mini" disabled class="continue-btn">已完成</el-button>
          </div>
          <div class="course-meta">最后学习时间：{{ course.lastStudyTime }}</div>
          <div class="course-progress-row">
            <el-progress :percentage="course.progress" :show-text="false" :stroke-width="6" color="#2EA2FA"></el-progress>
            <span class="course-progress-text">{{ course.progress }}%</span>
            <span class="course-time">学习时长：{{ course.timeSpent }}</span>
          </div>
        </div>
      </div>
      <div v-if="filteredCourses.length === 0" class="empty-tip">暂无学习记录</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AllLearningHistory',
  data() {
    return {
      timeFilter: 'all',
      statusFilter: 'all',
      allCourses: [
        { id: 1, name: '玩转未来', image: '/image/wl.png', lastStudyTime: '2025-02-14', progress: 60, timeSpent: '12小时', status: 'inProgress' },
        { id: 2, name: '激光切割课程', image: '/image/jg.png', lastStudyTime: '2024-11-14', progress: 30, timeSpent: '4小时', status: 'inProgress' },
        { id: 3, name: 'STEAM课程', image: '/image/steam.png', lastStudyTime: '2024-10-02', progress: 45, timeSpent: '7小时', status: 'inProgress' },
        { id: 4, name: '小小创客掌控板', image: '/image/zkb.png', lastStudyTime: '2024-08-10', progress: 100, timeSpent: '10小时', status: 'completed' },
        { id: 5, name: '科学创客教育实战', image: '/image/kx.png', lastStudyTime: '2024-08-01', progress: 100, timeSpent: '8小时', status: 'completed' },
        { id: 6, name: '孩子编程启蒙书', image: '/image/qm.png', lastStudyTime: '2024-07-15', progress: 0, timeSpent: '0小时', status: 'notStarted' },
      ],
    }
  },
  computed: {
    filteredCourses() {
      let list = this.allCourses;
      // 时间筛选（实际生产建议用dayjs等库处理日期）
      // 这里只做示例过滤
      if (this.statusFilter !== 'all') {
        list = list.filter(c => c.status === this.statusFilter);
      }
      return list;
    }
  }
}
</script>

<style scoped>
.learning-history-bg {
  min-height: 100vh;
  background: #eaf6fe;
  padding: 36px 0 0 0;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px 18px 40px;
}
.page-header h2 {
  font-size: 22px;
  font-weight: bold;
  color: #222;
  margin: 0;
}
.filter-section {
  display: flex;
  gap: 18px;
}
.course-list {
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding: 0 40px;
}
.course-item {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 12px 0 rgba(46,162,250,0.08);
  display: flex;
  align-items: center;
  padding: 18px 26px;
  min-height: 100px;
  position: relative;
}
.course-img {
  width: 84px;
  height: 84px;
  border-radius: 8px;
  object-fit: contain;
  margin-right: 24px;
  background: #fff;
  border: 1px solid #e3eaf1;
}
.course-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.course-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;
}
.course-title {
  font-size: 18px;
  font-weight: 500;
  color: #222;
}
.continue-btn {
  font-size: 13px;
  padding: 2px 12px;
  border-radius: 10px;
  font-weight: 400;
}
.course-meta {
  font-size: 13px;
  color: #8a97a8;
  margin-bottom: 6px;
}
.course-progress-row {
  display: flex;
  align-items: center;
  gap: 16px;
}
.course-progress-text {
  font-size: 13px;
  color: #2EA2FA;
}
.course-time {
  font-size: 13px;
  color: #888;
}
.empty-tip {
  color: #aaa;
  text-align: center;
  margin: 60px 0;
  font-size: 16px;
}
@media (max-width: 800px) {
  .page-header, .course-list {
    padding: 0 10px;
  }
  .course-img {
    width: 64px;
    height: 64px;
    margin-right: 12px;
  }
  .course-item {
    padding: 16px 10px;
  }
}
</style>